<template id="pc-details">
  <div class="maxw">
    <h2>Detalls Producte-Client</h2>
    <b-form>
      <b-row>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Producte:">
            {{ Producte.productoTitulo }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Cliente:">
            {{ Producte.cliente.nombre }}
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Descripción:">
            {{ Producte.productoDescripcion }}
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Unitats:">
              <p>{{ Producte.productoUnidades }}</p>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Preu unitari: (€)">
              {{ Producte.productoPrecio }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Preu: (€)">
             <p>{{ calculaPreu }}</p>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Dte: (%)">
              {{ Producte.productoDescuento }}
          </b-form-group>
        </b-col>
       <b-col>
          <b-form-group label-class="font-weight-bold" label="Dte: (€)">
             <p>{{ calculaDescompte }}</p>
          </b-form-group>
        </b-col>
       <b-col>
          <b-form-group label-class="font-weight-bold" label="Import: (€)">
             <p>{{ Producte.productoImporte }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Periode facturació (dies):">
              {{ Producte.productoDiasFacturacion }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Recurrent:">
            {{ Producte.isRecurrente }}
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6"></b-col>
        <b-col class="col text-right">
          <b-button class="mr-2" variant="outline-success" @click="$router.push({name: 'CPEdit', params: { producte: Producte },})">Editar</b-button>
          <b-button class="mr-2" variant="outline-danger" @click="$router.push({name: '', params: { producte: Producte },})">Esborrar</b-button>
          <b-button class="mr-2" variant="outline-primary"><router-link :to="{ name: 'CPs'}">Cancel</router-link></b-button>
        </b-col>
      </b-row>
      <b-form-input :hidden="true" type="text" v-model="Producte.productoIdentifier"></b-form-input>
      <b-form-input :hidden="true" type="text" v-model="Producte.clienteIdentifier"></b-form-input>
      <b-form-input :hidden="true" type="text" v-model="Producte.identifier"></b-form-input>
    </b-form>
  </div>
</template>

<script>
export default {
  props: {
    Producte: {}
  },
  computed: {
    calculaPreu: function () {
      return (this.Producte.productoPrecio * this.Producte.productoUnidades)
    },
    calculaDescompte: function () {
      return (-this.calculaPreu * (this.Producte.productoDescuento / 100))
    }
  }
}
</script>

<style scoped>
  .maxw {
    width: 80%;
    margin: 40px auto;
  }
</style>
